import {Injectable} from '@angular/core';
import {global} from '../../models/global';
import {Observable} from 'rxjs/Observable';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { JsonPipe } from '@angular/common';

@Injectable({
providedIn:'root'
})

export class DispatchToSDService{
  
    ROOT_URL: string = "";
    constructor(private http: Http) {
      let g: global = new global();
      this.ROOT_URL = g.getApiUrl();
    }
    DownloadExcel(userId: string, whLocation:string, product:string): Observable<any> {
      let body = { "userId": userId, "product": product, "whLocation":whLocation};
        let url = this.ROOT_URL + '/api/DispatchSD/DownloadExcel';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
          method: 'POST',
          url: url,
          headers: headers,
          body: body,
          responseType: ResponseContentType.Blob 
        })
        return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res;
        });
    }

    UploadDocument(documents: File, UserId: string): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", UserId);
        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
          method: 'POST',
          url: this.ROOT_URL + "/api/DispatchSD/UploadFiles",
          headers: headers,
          body: formData
        })
        return this.http.request(new Request(requestoptions))
          .map((res: Response) => {
            return res.json();
          });
      }

      // GetDispatchToSD(whLocation:any, product:any,userId :any, currentPage : any):Observable<any>{
      //   let url = this.ROOT_URL + '/api/DispatchSD/GetDispatchToSD';
      //   let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
      //   let body = { "userId": userId, "productId": product,"currentPage":currentPage, "whLocation":whLocation};
      //   let requestoptions: RequestOptions = new RequestOptions({
      //     method: 'POST',
      //     url: url,
      //     headers: headers,
      //     body: body,
      //   })
      //   return this.http.request(new Request(requestoptions))
      //   .map((res: Response) => {
      //     return res.json();
      //   });
      // }

      DownloadExcelForAdmin(userId: string, whLocation:string, product:string): Observable<any> {
        let body = { "userId": userId, "product": product, "whLocation":whLocation};
        let url = this.ROOT_URL + '/api/DispatchSD/DownloadExcelForAdmin';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
          method: 'POST',
          url: url,
          headers: headers,
          body: body,
          responseType: ResponseContentType.Blob
        })
        return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res;
        });
    }

    GetDispatchToSD(whLocation:any, product:any,userId :any):Observable<any>{
      let url = this.ROOT_URL + '/api/DispatchSD/GetDispatchToSD';
      let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
      let body = { "userId": userId, "product": product, "whLocation":whLocation};
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
      })
      return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
    }

    SaveDispatchToSD(data: any, userId: any): Observable<any> {
      let body = { "dispatchList": data, "userId": userId};
      let url = this.ROOT_URL + '/api/DispatchSD/SaveDispatchToSD';
  
      let headers = new Headers({
        'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token')
        , 'UserId': localStorage.getItem('dsu_userId'), 'RoleCode': localStorage.getItem('dsu_roleCode')
      });
  
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
      })
      return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res.json();
        });
    }

    UpdateStockIn(data: any): Observable<any> {
      let body = { "model": data};
      let url = this.ROOT_URL + '/api/DispatchSD/UpdateStockIn';
  
      let headers = new Headers({
        'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token')
        , 'UserId': localStorage.getItem('dsu_userId'), 'RoleCode': localStorage.getItem('dsu_roleCode')
      });
  
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: JSON.stringify(data),
      })
      return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res.json();
        });
    }
}